import { type BrandLogo, brandLogos } from '@/lib/brand-logos';
import type { ListOffer } from '~/lib/goliath/offers';
import type { Offer } from '~/lib/goliath/goliath.types';

export type LogoBrand = {
  name: string;
  slug: string;
} & Record<string, any>;

const findBrand = (slug: string): BrandLogo | undefined => brandLogos[slug];

export function getBrandLogo(slug: string, color: boolean | undefined = undefined) {
  const brandLogo = findBrand(slug);
  if (!brandLogo) return undefined;
  if (color && brandLogo.logoColor) return brandLogo.logoColor;
  return brandLogo.logoBw || brandLogo.logoColor;
}

export type BrandWithLogo = {
  logo: string | undefined;
  aspectRatio: string | undefined;
} & LogoBrand;

export function addLogo(brand: LogoBrand, color: boolean = false): BrandWithLogo {
  const brandLogo = findBrand(brand.slug);
  return {
    ...brand,
    logo: getBrandLogo(brand.slug, color),
    aspectRatio: brandLogo?.aspectRatio,
  };
}

export function getBrand(offer: ListOffer | Offer | undefined): undefined | BrandWithLogo {
  if (!offer?.product) return undefined;

  if (!offer?.product?.bundle) {
    // @ts-ignore
    return addLogo(offer?.product?.family?.brand || {}) || undefined;
  }
  const bundledProducts =
    'bundledProducts' in offer.product ? offer.product.bundledProducts || [] : [];
  // @ts-ignore
  const mainBrand = bundledProducts.length > 0 ? bundledProducts[0]?.family?.brand : undefined;
  // @ts-ignore
  if (mainBrand && bundledProducts.every(({ family }) => family?.brand?.slug === mainBrand.slug)) {
    return addLogo(mainBrand);
  }

  return undefined;
}
